import PSY_URI from '@/assets/Utils/api/url-const'
import { GET ,POST } from '@/assets/Utils/api/http';

/*
* 官网banner列表
* @param {}
* */

export const getBannerList =()=>{
   return GET(PSY_URI.BANNER_LIST_ON_OFFICIAL_WEBSITE);
}
/*
*  官网新闻动态列表
*  @param{
*    page 当前页码
*    limit 每页条数
*    typeCode 新闻类别编码
*  }
* */
export const GetsDynamicList =(param)=>{
    return GET(PSY_URI.NEWS_DYNAMIC_LIST,{
      data:param
    })
}

/*
*  官网产品与服务列表
*  @param{
*    page 当前页码
*    limit 每页条数
*  }
* */
export const GetPServicesList=(param)=>{
      return GET(PSY_URI.PRODUCTS_AND_SERVICES,{
        data:param
      });
}
/*
*   官网新闻动态列表
 * @param{
 *    page 当前页码
 *    limit 每页条数
 *    typeCode 新闻类别编码
 * }
 * */
export  const  GetNewsDynamicList =(param)=>{

  return GET(PSY_URI.NEWS_DYNAMIC_LIST,{
    data:param
  });
}
/*
* 视频宣传列表
* @param{
*   page 当前页码
*   limit 每页条数
*   typeCode 视频类别编码
* }
* */
export  const  GetVideoPromotionList =(param) =>{
    return GET(PSY_URI.VIDEO_PROMOTION_LIST,{
      data:param
    });
}
/*
 * 精英团队列表
 * @param{
 *  page 当前页码
 *  limit 每页条数
 * }
 * */
export const GetTeamList =(param)=>{
  return  GET(PSY_URI.ELITE_TEAM_LIST,{
    data:param
  });
}
/*
 * 加入我们列表
 * @param{
 *  page 当前页码
 *  limit 每页条数
 * }
 * */
export const GetJoinUs = (param)=>{
   return GET(PSY_URI.JOIN_US_lIST,{
     data:param
   });
}
/*
*  我们的客户列表
*  @param{
 *  page 当前页码
 *  limit 每页条数
*  }
* */
export  const GetCustomerList=(param) =>{
   return GET(PSY_URI.CUSTOMER_LIST,{
     data:param
   })
}

/*
 * 资质证书列表
 * @param{
 *  page 当前页码
 *  limit 每页条数
 * }
 * */
export const GetHonor = (param)=>{
  return GET(PSY_URI.HONOR_lIST,{
    data:param
  });
}
